import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataUltimoAcessoPortal = (): TabelaColuna => ({
  Chave: 'dataUltimoAcessoPortal',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataUltimoAcessoPortal)}</span>
  ),
  RenderizarCabecalho: () => (
    <div style={{ width: 90 }}>Data Últi. Aces. Portal</div>
  )
})
